import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import axiosInstance from "../../api/axiosInstance";

export default function ViewRx() {
  const { id: rxId } = useParams();
  const navigate = useNavigate();
  const [rx, setRx] = useState(null);

  useEffect(() => {
    axiosInstance
      .get(`getRxById/${rxId}`)
      .then((res) => {
        setRx(res.data.data);
      })
      .catch((err) => console.error("Error fetching Rx data:", err));
  }, [rxId]);

  if (!rx) return <div>Loading...</div>;

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span
                  style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                  onClick={() => navigate(-1)}
                  title="Back"
                >
                  &larr;
                </span>
                Rx Standard Info
              </h5>
            </div>
            <div className="card-body">
              <div className="row p20">
                {[
                  ["Medicine Name", rx.medicine_name],
                  ["Strength", rx.strength],
                  ["Unit", rx.unit],
                  ["Form", rx.form],
                  ["Route", rx.route],
                  ["Pack Size", rx.packet_size || rx.packSize],
                   ["Dose", rx.dose],
                  ["Active Substances", rx.activeSubstances],
                  ["Type", rx.productType],
                  ["Frequency", rx.frequency],
                  ["Duration", rx.duration],
                  ["Notes", rx.notes],
                ].map(([label, value], idx) => (
                  <div className="col-md-6 mb-3" key={idx}>
                    <label className="form-label">{label}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={value ?? ""}
                      disabled
                    />
                  </div>
                ))}
              </div>
              <div className="row p20">
                <div className="col-md-12 mb-3">
                  <label className="form-label">Warnings (Allergies)</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    value={(Array.isArray(rx?.allergies)
                      ? rx.allergies
                      : rx?.Allergies || rx?.warningList || []
                    )
                      .map((a) => a?.allergyName || a?.name || a?.label || a?.warningName)
                      .filter(Boolean)
                      .join(", ")}
                    disabled
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
